import React, {useEffect, useRef, useState} from 'react';
import Link from 'next/link';
import {useRouter} from 'next/router';
import LoadingNavigation from '@components/common/Loading/LoadingNavigation';

const MIN_LOADING_TIME = 300;

export default function LoadingDetailLink({href, children, ariaLabel}) {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(false);
    const loadingStartedAt = useRef(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const finishLoading = () => {
            const remainingTime = Math.max(0, MIN_LOADING_TIME - (Date.now() - loadingStartedAt.current));

            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => setIsLoading(false), remainingTime);
        };

        router.events.on('routeChangeComplete', finishLoading);
        router.events.on('routeChangeError', finishLoading);

        return () => {
            router.events.off('routeChangeComplete', finishLoading);
            router.events.off('routeChangeError', finishLoading);
            clearTimeout(timeoutRef.current);
        };
    }, [router.events]);

    if (!href) {
        return <span className="detail-link detail-link--disabled">{children}</span>;
    }

    const handleClick = event => {
        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        loadingStartedAt.current = Date.now();
        setIsLoading(true);
    };

    return (
        <>
            <Link href={href}>
                <a className="detail-link" aria-label={ariaLabel} onClick={handleClick}>
                    {children}
                </a>
            </Link>
            {isLoading && <LoadingNavigation fullscreen color="#006940" />}
        </>
    );
}
